/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterListOrgs } from "../../funcs/authClusterListOrgs.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListClusterOrgsRequest$inboundSchema,
};

export const tool$authClusterListOrgs: ToolDefinition<typeof args> = {
  name: "auth-cluster-list-orgs",
  description: `List all organizations`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterListOrgs(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
